import React from 'react';
import { createAssessmentsHooks } from '.';

const AllocationParams = () => {
    const semesterAndYearFilters = createAssessmentsHooks.useSemesterAndYearFilters()
    const preventDuplicateBatteries = createAssessmentsHooks.usePreventDuplicateBatteries()

    let filters = [
        ...semesterAndYearFilters,
        // preventDuplicateBatteries
    ]

    return (
        <div className='semester-and-year-filters'>
            {filters.map((item, index) =>
                <item.component key={index} {...item} />
            )}
        </div>
    )
}

export default AllocationParams;
